/*
 * Module for the Participant Associations Index Page
*/

rs.module("participant/account/associations/index",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            // needs to be inside document.ready since the grid needs to be rendered before we can attach listeners to links inside it
            $(document).ready(function () {

                // add click event to Add Role Links
                $.js(jsSelectors.associationTabs).js(jsSelectors.addRoleLink, { required: false, multiple: true }).click(function () {
                    var addUrl = $(this).data("addurl");
                    var isPerson = $.parseJSON($(this).data("isperson"));

                    // change text based on whether this is a person or not
                    $.js(jsSelectors.popup).js(jsSelectors.personNonPersonLabel).html(isPerson ? "person" : "entity");

                    var roleTypeLinks = $.js(jsSelectors.popup).js(jsSelectors.roleTypeLink, { multiple: true }).show();

                    // set the url for each add role type link
                    roleTypeLinks.each(function () {

                        // if this is a nonperson, only show beneficiary and representative links
                        if (!isPerson && $(this).data("roletype") != 2047 && $(this).data("roletype")) {
                            $(this).hide();
                        }

                        var resolvedUrl = addUrl;

                        if ($(this).data("roletype")) {
                            // replace the role type placeholder in the url with the selected role type
                            resolvedUrl = addUrl.replace("roleplaceholder", $(this).data("roletype"));
                        }
                        else {
                            // if there is no role type (representatives), then remove the route value
                            resolvedUrl = addUrl.replace("roleplaceholder/", "");
                        }

                        $(this).attr("href", resolvedUrl);
                    });
                });
            });

            // hide popup once a role type is selected
            $.js(jsSelectors.popup).js(jsSelectors.roleTypeLink, { multiple: true }).click(function () {
                $.js(jsSelectors.popup).modal('hide');
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);